<template>
  <b-modal
    v-model="isShowPopup"
    dialog-class="modal-export-data"
    @hidden="resetModal"
    :hide-footer="true"
    title="Export Data - Pilih Tanggal"
  >
    <b-card class="mb-3" header-bg-variant="transparent">
      <b-form @submit.prevent="confirmExport">
        <app-input-datepicker-range
          id="date-range"
          :modelFrom.sync="startDate"
          :modelTo.sync="endDate"
          size="sm"
          required
        />
        <b-row>
          <b-col cols="12" class="text-right">
            <b-button
              variant="secondary"
              size="sm"
              @click="resetModal"
              class="mr-2"
            >
              Cancel
            </b-button>
            <b-overlay
              :show="isExporting"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
            >
              <b-button
                variant="primary"
                size="sm"
                type="submit"
                :disabled="isExporting"
              >
                <b-icon-download class="mr-1"></b-icon-download>
                {{ isExporting ? "Exporting..." : "Export Data" }}
              </b-button>
            </b-overlay>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-modal>
</template>

<script>
import AppInputDatepickerRange from "@/components/AppInputDatepickerRange";

export default {
  props: ["openPopup", "resetMethod"],
  components: {
    AppInputDatepickerRange,
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      isExporting: false,
    };
  },
  computed: {
    isShowPopup: {
      get() {
        return this.openPopup;
      },
      set(value) {
        if (!value) {
          this.resetModal();
        }
      },
    },
  },
  methods: {
    resetModal() {
      this.startDate = null;
      this.endDate = null;
      this.isExporting = false;
      this.$emit("resetMethod");
    },
    confirmExport() {
      if (!this.startDate || !this.endDate) {
        this.$store.dispatch(
          "addErrorMessageGlobal",
          "Please select both start and end dates."
        );
        return;
      }

      this.isExporting = true;
      this.$emit("confirmExport", {
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
  },
};
</script>

<style>
.modal-export-data {
  width: 650px !important;
  max-height: 200px;
}
</style>
